export default "__VITE_ASSET__7qHAGCig__"